export default "<p>\r\n  error-dialog works!\r\n</p>\r\n";